import React, { Fragment } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import TankTypeText from '~/components/tankTypeText/tankTypeText';
import LotStatusText from '~/components/lotStatusText/lotStatusText';
import UserFullname from '~/components/userFullname/userFullname';

export const getLotQuery = gql`
  query lot($id: Int!) {
    lot(id: $id) {
      id
      product {
        id
        name
        abv
      }
      reference
      notes
      status
      startDate
      isSample
      currentVolume
      volume
      createdByUser {
        id
        firstName
        lastName
      }
      startedByUser {
        id
        firstName
        lastName
      }
    }
  }
`;

const ScheduledLot = ({ event, lot }) => {
  const today = new Date();
  const startDate = moment(lot.startDate).startOf('d');
  return (
    <Fragment>
      <p>
        The lot{' '}
        <strong>
          <Link to={`/lots/${lot.id}`}>{lot.reference}</Link>
        </strong>
        {`${today < startDate ? 'is' : 'was'} scheduled to begin brewing ${startDate.fromNow()} (${startDate.format(
          'dddd Do MMMM'
        )})`}
      </p>
      <h4 className="table-header mv0">Status</h4>
      <p>
        <LotStatusText status={lot.status} capitalise />
      </p>
      <h4 className="table-header mv0">Volume</h4>
      <p>{lot.volume}L</p>
      <h4 className="table-header mv0">Product</h4>
      <p>
        <Link to={`/products/${lot.product.id}`}>
          {lot.product.name} ({lot.product.abv}
          %)
        </Link>
      </p>
      <h4 className="table-header mv0">Start date</h4>
      <p>{moment(startDate).format('dddd Do MMMM')}</p>
      <h4 className="table-header mv0">Scheduled By</h4>
      <p>
        <UserFullname user={lot.createdByUser} />
      </p>
      {lot.status === 'IN_PROGRESS' && (
        <Fragment>
          <h4 className="table-header mv0">Started By</h4>
          <p>
            <UserFullname user={lot.startedByUser} />
          </p>
        </Fragment>
      )}
    </Fragment>
  );
};

const LotTransfer = ({ event, lot, consolidatedLot }) => {
  const { lotTransfer } = event.resource;
  const today = new Date();
  const startDate = moment(lotTransfer.transferDate).startOf('d');
  let detail = '';
  switch (event.resource.lotTransfer.type) {
    case 'TANK':
      detail = (
        <span>
          Transfer to <TankTypeText type={lotTransfer.tankType} />
        </span>
      );
      break;
    case 'VESSEL':
      detail = <span>Vessel description: {lotTransfer.vesselDescription}</span>;
      break;
    case 'LOCATION':
      detail = 'Transfer to a new location (detail implementation pending)';
      break;
    case 'DRY_HOP':
      detail = 'Dry hop';
      break;
    case 'CLARIFICATION':
      detail = 'Add clarification';
      break;
    default:
      detail = 'Invalid transfer type';
      break;
  }

  return (
    <Fragment>
      <p>
        The transfer{' '}
        <strong>
          <Link to={`/lots/${lot.id}`}>{lot.reference} </Link>
        </strong>
        {`${today < startDate ? 'is' : 'was'} scheduled to be completed ${startDate.fromNow()} (${startDate.format(
          'dddd Do MMMM'
        )})`}
      </p>
      <h4 className="table-header mv0">Details</h4>
      <p>{detail}</p>
      <h4 className="table-header mv0">Lot status</h4>
      <p>
        <LotStatusText status={lot.status} capitalise />
      </p>
      <h4 className="table-header mv0">Lot scheduled By</h4>
      <p>
        <UserFullname user={lot.createdByUser} />
      </p>
      {lot.status === 'IN_PROGRESS' && (
        <Fragment>
          <h4 className="table-header mv0">Lot started By</h4>
          <p>
            {lot.startedByUser ? <UserFullname user={lot.startedByUser} /> : <UserFullname user={lot.createdByUser} />}
          </p>
        </Fragment>
      )}
    </Fragment>
  );
};

const LotDescription = ({ event, lot }) => {
  if (event.resource.type === 'SCHEDULED_LOT') {
    return <ScheduledLot event={event} lot={lot} />;
  } else if (event.resource.type === 'LOT_TRANSFER') {
    return <LotTransfer event={event} lot={lot} />;
  }
  return <p>Invalid agenda type.</p>;
};

const Lot = ({ event, lotId, isOpen, onToggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={onToggle}>
      <ModalHeader toggle={onToggle}>Agenda item detail</ModalHeader>
      <ModalBody>
        <Query query={getLotQuery} variables={{ id: lotId }} fetchPolicy={'cache-and-network'}>
          {props => {
            const { loading, error, data } = props;
            if (loading) {
              return <Spinner className="absolute absolute-center stroke-brand-red" />;
            }

            if (error) {
              console.log(error);
              return <Alert color="danger">Sorry, there was an error getting the details</Alert>;
            }

            const { consolidatedLot, lot } = data;
            return (
              <div>
                <h2 className="f4">{event.title}</h2>
                <LotDescription event={event} consolidatedLot={consolidatedLot} lot={lot} />
              </div>
            );
          }}
        </Query>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onToggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Lot;



// WEBPACK FOOTER //
// ./src/containers/agendaLotEventDetailModal/agendaLotEventDetailModal.jsx